<template>
  <div class="index container">
    <video class="index__video" playsinline autoplay :muted="muted" @play="enableSoundControl" loop poster="/static/images/bill.jpg">
      <source src="/static/videos/bill.webm" type="video/webm">
      <source src="/static/videos/bill.mp4" type="video/mp4">
    </video>
    <div class="index__sound-control" v-if="showSoundControls">
      <a href="#" @click="toggleSound">{{ soundText }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      muted: 'muted',
      showSoundControls: false
    }
  },
  computed: {
    soundText () {
      if (this.muted) return `${this.tapOrClick} for sound`
      return `${this.tapOrClick} to mute`
    },
    tapOrClick () {
      if (window.isTouch) {
        return 'Tap'
      }
      return 'Click'
    }
  },
  methods: {
    enableSoundControl () {
      this.showSoundControls = true
    },
    toggleSound () {
      this.muted = !this.muted
    }
  }
}
</script>

<style lang="sass">

@import '../assets/sass/utilities/variables'
@import '../assets/sass/utilities/mixins'

.index
  height: 100vh
  width: 100vw
  display: flex

.index__video
  position: fixed
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  min-width: 100vw
  min-height: 100vh
  width: auto
  height: auto
  overflow: hidden

.index__sound-control
  position: fixed
  bottom: 20px
  left: 50%
  transform: translateX(-50%)
  width: 100vw
  max-width: 1400px
  font-weight: 500
  line-height: 1
  text-align: right
  padding-left: 20px
  padding-right: 20px
  +small
    padding-left: 50px
    padding-right: 50px
    bottom: 50px
  a
    color: #fff
    text-decoration: none
    font-size: 12px

</style>



// WEBPACK FOOTER //
// Index.vue?10665cd8